<template>
  <div v-if="userScrolled">
    <button
      @click="backToTop"
      class="back-to-top-button button button-tertiary d-print-none"
    >
      <img src="../assets/arrow-upward.svg" alt="arrow-up" class="icon-svg" />
      <span>Til toppen</span>
    </button>
  </div>
</template>
<script lang="ts" setup>
import { ref } from "vue";
window.onscroll = () => {
  if (
    document.body.scrollTop > 100 ||
    document.documentElement.scrollTop > 100
  ) {
    userScrolled.value = true;
  } else {
    userScrolled.value = false;
  }
};
const backToTop = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};
const userScrolled = ref(false);
</script>
